__turbopack_context__.v({
  "className": "suissbook_cfdf891c-module__OspCgG__className",
  "variable": "suissbook_cfdf891c-module__OspCgG__variable",
});
